import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";

// images
import LOGO_MTN2 from "./../../assets/images/mtn-logo.svg";

// api
import {
  connexionAbonneByPassword,
  getAbonneInfo_allRight,
} from "../../services/abonne/AbonneRequest";
import { isAuthenticated } from "../../utils/AuthGuard";

const PasswordAccess = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [password, setPassword] = useState("");
  const [user, setUser] = useState(null);

  const checkPassword = () => {
    setLoading(true);
    setErrorMessage("");

    const data = {
      id: 0,
      numero: "",
      password: password,
      username: user.numero,
    };

    connexionAbonneByPassword(data)
      .then((res) => {
        setLoading(false);
        sessionStorage.setItem("token", res.data.accessToken);
        sessionStorage.setItem("user", JSON.stringify(user));
        navigate("/forfaits/acheter");
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        if (err.response) {
          setErrorMessage(err.response.data.donnee);
        } else {
          setErrorMessage("Une erreur s'est produite, essayer plus tard");
        }
      });
  };

  useEffect(() => {
    const customerNumber = sessionStorage.getItem('customer_number') ? sessionStorage.getItem('customer_number') : ""
    getAbonneInfo_allRight(customerNumber)
      .then((res) => {
        setUser(res.data.donnee);
        sessionStorage.setItem("user", JSON.stringify(res.data.donnee));
        if (isAuthenticated() && res.data.donnee.motdepasseisactif && sessionStorage.getItem("token")) {
          navigate("/forfaits/acheter");
        } else if (!res.data.donnee.motdepasseisactif && !sessionStorage.getItem("token")) {
          navigate("/forfaits/acheter");
        }
      })
      .catch((err) => {
        console.log("api error", err);
      });

    if (isAuthenticated() && user && user.motdepasseisactif && sessionStorage.getItem("token")) {
      navigate("/forfaits/acheter");
    } else if (isAuthenticated() && user && !user.motdepasseisactif && sessionStorage.getItem("token")) {
      navigate("/forfaits/acheter");
    } else if (user && !user.motdepasseisactif && !sessionStorage.getItem("token")) {
      navigate("/forfaits/acheter");
    } else if (user && user.motdepasseisactif && !sessionStorage.getItem("token")) {
    }
  }, []);

  return (
    <div className="w-full h-screen bg-gray-mtn flex flex-col items-center pt-32">
      <div className="mb-10">
        <img src={LOGO_MTN2} alt="" className="w-32" />
      </div>
      <div className="max-w-96 h-fit bg-white shadow-xl rounded-xl border mx-3 p-5">
        <h1 className="text-center text-lg font-bold mx-5">
          Entrer votre mot de passe pour continuer
        </h1>
        <div className="mt-8">
          <input
            disabled={loading}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            placeholder="*****"
            className="input input-bordered w-full bg-gray-mtn"
          />
        </div>
        <button
          disabled={loading}
          className="bg-jaune-mtn font-bold text-sm w-full h-10 rounded-lg mt-5 flex items-center justify-center"
          onClick={checkPassword}
        >
          {!loading ? (
            "Valider"
          ) : (
            <ThreeDots
              height="40"
              width="40"
              radius="9"
              color="#000"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={loading}
            />
          )}
        </button>
        {errorMessage ? (
          <div className="mt-4">
            <p className="text-red-500 text-center font-bold">{errorMessage}</p>
          </div>
        ) : null}
        <div className="text-center mt-3">
          <Link to='/forget-password'>
            <button className="underline">Mot de passe oublié</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PasswordAccess;
